import PropTypes from 'prop-types';
import React from 'react';
import TextField from 'material-ui/TextField';
import withKeyLayer from 'react-key-layers';
import dialogStyle from '../../../../styles/presentational/ClassRoom/Inbox/inboxGroupParticipantsStyle';
import style from '../../../../styles/presentational/ClassRoom/Inbox/inboxCreateGroupStyle';
import onlyWhenTrue from '../ConversationModal/onlyWhenTrue';
import { flow } from '../utils';
import * as TEXT from '../../../../constants/texts';

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../common/Dialog';

class ChangeGroupName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: '',
    };
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeGroupName = this.handleChangeGroupName.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  handleChangeName(e) {
    this.setState({ groupName: e.target.value });
  }

  handleChangeGroupName() {
    const { groupName } = this.state;
    const { changeGroupName, group } = this.props;

    if (groupName) {
      const changed = changeGroupName(groupName, group.objectId);
      changed
        .then(() => this.handleRequestClose())
        .catch(() => this.handleRequestClose());
    }
  }

  handleRequestClose() {
    const { handleClose } = this.props;
    handleClose();
  }

  render() {
    const { isChangingGroupName, open, participants, icon, title } = this.props;

    const { addingParticipants, groupName } = this.state;

    return (
      <Dialog
        id="rename-conversation"
        open={open}
        onClose={this.handleRequestClose}
        maxWidth="md"
        style={{ zIndex: 2500 }}
      >
        <DialogTitle
          id="rename-conversation-dialogtitle"
          onClose={this.handleRequestClose}
        >
          Rename group
        </DialogTitle>
        <DialogContent>
          <div style={dialogStyle.wrapper}>
            <div style={dialogStyle.infoWrapper}>
              {participants.length > 2 && icon(30)}
              <span style={dialogStyle.labelsWrapper}>
                <div style={dialogStyle.title}>{title}</div>
                <span style={dialogStyle.subtitle}>
                  {!addingParticipants && `${participants.length} participants`}
                </span>
              </span>
            </div>
            <div style={dialogStyle.participantAutocomplete}>
              <TextField
                hintText={TEXT.INPUT_TEXT_INBOX_GROUP}
                floatingLabelText="New Group Name"
                onChange={this.handleChangeName}
                style={style.groupNameField}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions
          primary={{
            label: TEXT.BUTTON_SAVE,
            onClick: this.handleChangeGroupName,
            loading: isChangingGroupName,
            disabled: groupName.length === 0,
          }}
          secondary={{
            label: 'Cancel',
            onClick: this.handleRequestClose,
          }}
        />
      </Dialog>
    );
  }
}

ChangeGroupName.propTypes = {
  changeGroupName: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  group: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon: PropTypes.func.isRequired,
  isChangingGroupName: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  participants: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

ChangeGroupName.defaultProps = {
  isChangingGroupName: false,
};

const wrap = flow(withKeyLayer, onlyWhenTrue(['open']));

export default wrap(ChangeGroupName);
